import React from "react";
import { Box } from "@chakra-ui/react";

export const InfoIcon = (props) => {
  return (
    <Box {...props}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="22"
        height="22"
        viewBox="0 0 32 32"
      >
        <path
          fill="#424770"
          fillRule="nonzero"
          d="M 16 3 C 8.832031 3 3 8.832031 3 16 C 3 23.167969 8.832031 29 16 29 C 23.167969 29 29 23.167969 29 16 C 29 8.832031 23.167969 3 16 3 Z M 16 5 C 22.085938 5 27 9.914062 27 16 C 27 22.085938 22.085938 27 16 27 C 9.914062 27 5 22.085938 5 16 C 5 9.914062 9.914062 5 16 5 Z M 15 10 L 15 12 L 17 12 L 17 10 Z M 15 14 L 15 22 L 17 22 L 17 14 Z M 15 14 "
        />
      </svg>
    </Box>
  );
};
